import { find, register } from '../../../../Javascript/Sysmex/Utils'

var cancelTimer

const ScientificCalendar = el => {
  document.calendarIsDisabled = false
  document.calendarWasWrong = false
  document.sciCalPrefix = el.getAttribute('data-prefix')
  const submitButton = find('.' + document.sciCalPrefix + 'submit', el)
  submitButton.addEventListener('click', submit.bind(this, el))
  var hideTimer = el.getAttribute('data-hiddentimer')
  document.labelTryAgain = el.getAttribute('data-label-tryAgain')
  if (hideTimer === '1') {
    timer()
  }
  const answers = el.querySelectorAll('.' + document.sciCalPrefix + 'answer', el)
  answers.forEach(function (el) {
    el.addEventListener('click', clickAnswer.bind(this, el))
  })
}

const timer = () => {
  var seconds = 0
  var minutes = 0
  var timer = document.getElementById('sc-timer')

  function incrementSeconds () {
    seconds += 1
    if (seconds === 60) {
      seconds = 0
      minutes += 1
    }
    timer.innerText = minutes.toLocaleString('de-DE', { minimumIntegerDigits: 2, useGrouping: false }) + ':' + seconds.toLocaleString('de-DE', { minimumIntegerDigits: 2, useGrouping: false })
  }
  cancelTimer = setInterval(incrementSeconds, 1000)
}

const clickAnswer = el => {
  if (document.calendarWasWrong) {
    reset()
  }

  if (!document.calendarIsDisabled) {
    const input = el.querySelector('input:not([type="hidden"])')
    if (input.checked) {
      input.checked = false
    } else {
      input.checked = true
    }

    const inputs = document.querySelectorAll('input:not([type="hidden"])')
    document.hasCheckedInputs = false
    inputs.forEach(function (el) {
      if (el.checked) {
        document.hasCheckedInputs = true
      }
    })
  }
}

const submit = el => {
  const submitButton = find('.' + document.sciCalPrefix + 'submit', el)

  const answers = document.querySelectorAll('.' + document.sciCalPrefix + 'answer')
  let hasWrongAnswer = false
  let hasRightAnswer = false

  answers.forEach(function (el) {
    if (el.getAttribute('isCorrect') === '1' && el.querySelector('input:not([type="hidden"])').checked === true) {
      el.classList.add(document.sciCalPrefix + 'is--correct')
      hasRightAnswer = true
    }
    if (el.getAttribute('isCorrect') === '1' && el.querySelector('input:not([type="hidden"])').checked === false) {
      el.classList.remove(document.sciCalPrefix + 'is--correct')
    }
    if (el.getAttribute('isCorrect') === '0' && el.querySelector('input:not([type="hidden"])').checked === true) {
      el.classList.add(document.sciCalPrefix + 'is--false')
      hasWrongAnswer = true
    }
    if (el.getAttribute('isCorrect') === '1' && el.querySelector('input:not([type="hidden"])').checked === false) {
      hasWrongAnswer = true
    }
    if (el.getAttribute('isCorrect') === '0' && el.querySelector('input:not([type="hidden"])').checked === false) {
      el.classList.remove(document.sciCalPrefix + 'is--false')
    }
  })

  if (!hasWrongAnswer && document.hasCheckedInputs) {
    document.querySelector('.' + document.sciCalPrefix + 'modalTriggerSuccess').click()
    submitButton.classList.add(document.sciCalPrefix + 'is--completed')
    clearInterval(cancelTimer)
    document.calendarIsDisabled = true
  }

  if (hasRightAnswer && hasWrongAnswer && document.hasCheckedInputs) {
    document.querySelector('.' + document.sciCalPrefix + 'modalTriggerPartly').click()
    submitButton.textContent = document.labelTryAgain
    document.calendarWasWrong = true
  }

  if (!hasRightAnswer && hasWrongAnswer && document.hasCheckedInputs) {
    document.querySelector('.' + document.sciCalPrefix + 'modalTriggerFail').click()
    submitButton.textContent = document.labelTryAgain
    document.calendarWasWrong = true
  }

  if (!document.hasCheckedInputs) {
    document.querySelector('.' + document.sciCalPrefix + 'modalTriggerEmpty').click()
  }
}

const reset = el => {
  document.calendarWasWrong = false

  const answers = document.querySelectorAll('.' + document.sciCalPrefix + 'answer')
  answers.forEach(function (el) {
    el.classList.remove(document.sciCalPrefix + 'is--false')
    el.classList.remove(document.sciCalPrefix + 'is--correct')
  })
}

register('ScientificCalendar', ScientificCalendar)
